import createSvgIcon from '../Utils/CreateSvgIcon';

export const Finance = createSvgIcon(
  <path
    d="M3 5L18 5V3L3 3L3 5ZM14.628 18.914H13.298L13.298 21L21.04 21V18.914L17.092 18.914V16.828L19.738 16.828V14.882L17.092 14.882V14.546C17.092 13.8647 17.2413 13.3513 17.54 13.006C17.848 12.6513 18.296 12.474 18.884 12.474C19.472 12.474 20.0693 12.6233 20.676 12.922L20.984 10.892C20.6667 10.724 20.298 10.5933 19.878 10.5C19.4673 10.4067 19.0473 10.36 18.618 10.36C17.3487 10.36 16.364 10.7193 15.664 11.438C14.9733 12.1567 14.628 13.174 14.628 14.49V14.882H13.368V16.828H14.628V18.914ZM16 9L3 9L3 7L16 7V9ZM3 13L12 13V11L3 11L3 13ZM10 17H3L3 15L10 15L10 17ZM3 21H10V19H3L3 21Z"
    fillRule="evenodd"
  />,
  'Finance',
);
